export default __webpack_public_path__ + "static/media/instagram.1f937f7f.svg";